import { render, staticRenderFns } from "./WhsD_CompanyProfile.vue?vue&type=template&id=c40475c0"
import script from "./WhsD_CompanyProfile.vue?vue&type=script&lang=js"
export * from "./WhsD_CompanyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports